var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "top-view" }, [
    _c("div", { staticClass: "wrapper" }, [
      _vm.currentRouteName !== "Index" &&
      _vm.currentRouteName !== "Locked" &&
      _vm.isCallCenterAdmin
        ? _c("div", { staticClass: "link-header" }, [
            _c(
              "a",
              {
                staticStyle: { "margin-right": "20px" },
                attrs: { href: "" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.toSettings($event)
                  }
                }
              },
              [_c("span", [_vm._v("Einstellungen")])]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.currentRouteName !== "Index" &&
      _vm.currentRouteName !== "Locked" &&
      (_vm.isCallCenterAdmin || _vm.isGCS)
        ? _c("div", { staticClass: "link-header" }, [
            _c(
              "a",
              {
                staticStyle: { "margin-right": "20px" },
                attrs: { href: "" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.toGCS($event)
                  }
                }
              },
              [_c("span", [_vm._v("Vorgänge für GCS")])]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.currentRouteName !== "Index"
        ? _c(
            "div",
            { staticClass: "link-header" },
            [
              _c(
                "a",
                {
                  attrs: { href: "" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.logout($event)
                    }
                  }
                },
                [
                  _c("span", { staticStyle: { "margin-right": "4px" } }, [
                    _vm._v("Abmelden")
                  ])
                ]
              ),
              _vm._v(" "),
              _c("v-icon", { staticStyle: { color: "white" } }, [
                _vm._v("login")
              ])
            ],
            1
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "section",
      { staticStyle: { "box-shadow": "0 10px 20px rgba(15, 30, 50, 0.05)," } },
      [
        _c(
          "v-layout",
          {
            staticClass: "logo-section",
            attrs: { row: "", "fill-height": "" }
          },
          [
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.werbas-ksr.com/",
                  title: "zur Startseite"
                }
              },
              [
                _c("img", {
                  staticClass: "img-logo",
                  attrs: {
                    alt: "WERBAS//KSR Logo",
                    src: require("@/common/img/werbas_ksr_logo.svg"),
                    width: "100%",
                    height: "100%"
                  }
                })
              ]
            ),
            _vm._v(" "),
            _vm.currentRouteName == "SelectedCustomer"
              ? _c(
                  "v-flex",
                  { attrs: { id: "buttons-terms-container", xs12: "" } },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "form-button",
                        attrs: { disabled: _vm.isNewSupportButtonDisabled },
                        on: {
                          click: function($event) {
                            return _vm.toNewSupportRequest()
                          }
                        }
                      },
                      [_vm._v("Neuen Support-Vorgang anlegen")]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        staticClass: "form-button",
                        on: {
                          click: function($event) {
                            return _vm.toBack()
                          }
                        }
                      },
                      [_vm._v("Kunden suchen")]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showZuruckButton(_vm.currentRouteName)
              ? _c(
                  "v-flex",
                  { attrs: { id: "buttons-terms-container", xs12: "" } },
                  [
                    _vm.currentRouteName == "SettingsCallCenterIndex"
                      ? _c(
                          "v-btn",
                          {
                            staticClass: "form-button",
                            attrs: { disabled: !_vm.settingsValid },
                            on: {
                              click: function($event) {
                                return _vm.saveSettings()
                              }
                            }
                          },
                          [_vm._v("Einstellungen speichern")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showZuruckButton(_vm.currentRouteName)
                      ? _c(
                          "v-btn",
                          {
                            staticClass: "form-button",
                            on: {
                              click: function($event) {
                                return _vm.toBackIndexFromSetting()
                              }
                            }
                          },
                          [_vm._v("Zurück")]
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("v-layout", {
          staticClass: "navigation-section",
          attrs: { row: "", "fill-height": "" }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }